import { UpdateDriverInput } from '@allocab/allocab-driver-shared-types';
import { useMutation } from '@tanstack/react-query';
import type { UseMutationOptions } from '@tanstack/react-query';

import { driverApi } from '../services/network/Api';

type Input = UpdateDriverInput & { userKey: string };

const patchDriverUser = ({ userKey, ...input }: Input) =>
  driverApi.patch<UpdateDriverInput, void>(`/v1/driver/user/${userKey}`, input);

export const usePatchDriverUser = (options: UseMutationOptions<void, unknown, Input> = {}) =>
  useMutation<void, unknown, Input>({
    mutationFn: patchDriverUser,
    ...options,
  });
